import {
  ClickResultWidgetLinkEvent,
  AutodataCustomEventTypes,
} from "./ts/types";

export default (autoData: AutoData): DisposableApp => {
  const onClickAllResultsWidgetLinkAutodataHandler = () => {
    autoData.sendEvent({
      category: "faq|searchBar",
      action: "moreResult",
      label: "seeMore",
    });
  };

  const onClickResultWidgetLinkAutodataHandler = ({
    detail,
  }: ClickResultWidgetLinkEvent) => {
    const { result, searchText } = detail;

    autoData.sendEvent({
      faqThematic: result.question.category.thematic.id,
      faqCategory: result.question.category.id,
      faqQuestion: result.question.id,
      faqKeyword: searchText || null,
      category: "faq|searchBar",
      action: "openQuestion",
      label: result.question.id,
    });
  };

  window.addEventListener(
    AutodataCustomEventTypes.ON_CLICK_ALL_RESULTS_WIDGET_LINK,
    onClickAllResultsWidgetLinkAutodataHandler as EventListener
  );

  window.addEventListener(
    AutodataCustomEventTypes.ON_CLICK_RESULT_WIDGET_LINK,
    onClickResultWidgetLinkAutodataHandler as EventListener
  );

  return function disposableCallback(): void {
    window.removeEventListener(
      AutodataCustomEventTypes.ON_CLICK_ALL_RESULTS_WIDGET_LINK,
      onClickAllResultsWidgetLinkAutodataHandler as EventListener
    );

    window.removeEventListener(
      AutodataCustomEventTypes.ON_CLICK_RESULT_WIDGET_LINK,
      onClickResultWidgetLinkAutodataHandler as EventListener
    );
  };
};
